// src/services/api.jsx
import axios from 'axios';

// Функция для получения CSRF-токена из куки
function getCSRFToken() {
  const name = 'csrf_token';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
  }
});

// Перехватчик запросов
api.interceptors.request.use(
  (config) => {
    // Добавляем CSRF токен для POST/PUT/PATCH запросов
    if (['post', 'put', 'patch'].includes(config.method?.toLowerCase())) {
      const csrfToken = getCSRFToken();
      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
      }
    }
    
    // Удаляем заголовок Content-Type для GET запросов
    if (config.method?.toLowerCase() === 'get') {
      delete config.headers['Content-Type'];
    }
    
    // Исключаем медиа-запросы из стандартной обработки
    const isMediaRequest = config.url?.includes('/sound/audio');
    const isBlobRequest = config.responseType === 'blob';
    
    if (isMediaRequest || isBlobRequest) {
      // Удаляем заголовки, которые могут мешать работе с медиа
      delete config.headers['X-Requested-With'];
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Перехватчик ответов
api.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data.message && typeof window.showToast === 'function') {
      window.showToast(data.message);
    }

    if (data.error && typeof window.showToast === 'function') {
      window.showToast(data.error);
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Очищаем localStorage и перенаправляем на страницу входа
      localStorage.clear();
      window.location.href = '/login';
      return Promise.reject(error);
    }

    if (error.response?.data?.error && typeof window.showToast === 'function') {
      window.showToast(error.response.data.error);
    } else if (typeof window.showToast === 'function') {
      window.showToast('Произошла ошибка при запросе.');
    }

    return Promise.reject(error);
  }
);

export default api;
